module.exports = __webpack_public_path__ + "img/slider_todolist.a564f2be.png";